import * as React from 'react';
import { Link as RouterLink } from "react-router-dom";
import { AppRoutes } from './constants/routes';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import HomeIcon from '@mui/icons-material/Home';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import FavoriteIcon from '@mui/icons-material/Favorite';

import { useAuthProvider } from './utils/auth';

export default function SimpleBottomNavigation() {
  const [value, setValue] = React.useState(0);
  const {isAuthed, isListening} = useAuthProvider();

  // Listening navigation: shown to visitors and to anyone in the listening
  // experience, hidden on account dashboards
  if (isAuthed && !isListening) {
    return null;
  }

  return (
    <Box>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, bgcolor: 'background.paper', zIndex: 1000 }} elevation={3}>

        <BottomNavigation        
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          sx={{
            display: { xs: 'flex', sm: 'flex', md: 'none' }
          }}
        >
          <BottomNavigationAction
            component={RouterLink}
            to={AppRoutes.Home2}
            icon={<HomeIcon />}
          />

          <BottomNavigationAction
            icon={<SearchIcon />}
            component={RouterLink}
            to={AppRoutes.Search}
          />
          
          { isAuthed && isListening && 
            <>
              <BottomNavigationAction
              label="Library"
              component={RouterLink}
              to={AppRoutes.Library}
              icon={<LibraryMusicIcon />}
              />

              <BottomNavigationAction
                label="Likes"
                component={RouterLink}
                to={AppRoutes.LikesPage}
                icon={<FavoriteIcon />}
              />
            </>
          }

        </BottomNavigation>
      </Paper>
    </Box>
  );
}
